<template>
  <div class="layout-center-wrap">
    <!-- 상단 타이틀 -->
    <div class="page-tit__wrap">
      <h1 class="page-tit__sub">신고포상제</h1>
      <p class="page-tit">명예의 전당</p>
    </div>
    <!-- 명예의 전당 리스트 -->
    <h2 class="section-title">명예의 전당 리스트</h2>
    <div class="notice-box">
      <p class="notice-box__tit">
        화이트해커의 취약점 신고 활성화를 위해, 우수 신고자를 공개하는 「명예의
        전당」 운영
      </p>
      <p class="notice-box__text">
        S/W 보안 취약점 신고포상제 참여한 신고자 중, 포상금과 포상 건수를
        바탕으로 상위 10명 선정
      </p>
      <p class="notice-box__text">
        ※ 상위 10명 선정 기준 : 포상금(100%) 우선, 동일 시 포상 건수가 적은 순
        <br />
        ※ 뱃지는 상위 3명에게 부여됩니다.
      </p>
    </div>
    <!-- 연도별 TOP10 -->
    <section class="ranking-yearly">
      <div class="section-title__wrap">
        <h2 class="section-title">연도별 TOP10</h2>

        <label for="year" class="sr-only">년도</label>
        <select name="year" id="year" v-model="year" @change="getList()">
          <option v-for="item in displayYears" :key="item" :value="item">
            {{ item }}
          </option>
        </select>
      </div>
      <!-- 1~3위 리스트 -->
      <ol class="ranking-yearly__podium">
        <li
          v-for="(item, index) in items.slice(0, 3)"
          :key="index"
          :class="[
            'podium-card',
            {
              'podium-card--gold': index === 0,
              'podium-card--silver': index === 1,
              'podium-card--bronze': index === 2,
            },
          ]"
        >
          <img
            class="podium-card__trophy"
            :src="
              index === 0 ? img_gold : index === 1 ? img_silver : img_bronze
            "
            :alt="
              index === 0
                ? 'Gold trophy'
                : index === 1
                ? 'Silver trophy'
                : 'Bronze trophy'
            "
          />
          <div class="podium-card__meta">
            <span
              :class="[
                'podium-card__nickname',
                {
                  gold: index === 0,
                  silver: index === 1,
                  bronze: index === 2,
                },
              ]"
              >{{ item.nickName }}</span
            >
          </div>
          <h3 class="podium-card__name">{{ item.name }}</h3>
          <p class="podium-card__link">
            <a
              v-if="item.webUrl"
              :href="item.webUrl"
              target="_blank"
              rel="noopener"
              >{{ nullFormatter(item.webUrl) }}</a
            >
          </p>
        </li>
      </ol>
      <!-- 4~10위 리스트 -->
      <ol class="ranking-yearly__list" start="4">
        <li
          class="ranking-yearly__item"
          v-for="(item, index) in items.slice(3, 10)"
          :key="index"
        >
          <span class="ranking-yearly__item__badge">{{ index + 4 }}</span>
          <div class="ranking-yearly__item__body">
            <div class="ranking-yearly__item__name">
              {{ nullFormatter(item.name) }}
            </div>
            <div class="ranking-yearly__item__meta">
              <span class="ranking-yearly__item__nickname">{{
                nullFormatter(item.nickName)
              }}</span>
              <p class="ranking-yearly__item__link">
                웹주소 : {{ nullFormatter(item.webUrl) }}
              </p>
            </div>
          </div>
        </li>
      </ol>
    </section>
  </div>
</template>

<script>
import { inject, onMounted, ref } from "vue";
import dc from "@/component/DataChk.js";
import img_gold from "../../assets/img/img_gold.png";
import img_silver from "../../assets/img/img_silver.png";
import img_bronze from "../../assets/img/img_bronze.png";
import { useStore } from "vuex";
export default {
  setup() {
    const axios = inject("axios");
    const store = useStore();
    const showLoading = () => store.dispatch("loading/show");
    const hideLoading = () => store.dispatch("loading/hide");

    // data 정의
    const year = ref(0);
    const displayYears = ref([]);
    const items = ref([]);

    //methods 정의
    const getList = () => {
      showLoading();
      axios
        .post("/core/pu/view/honor/get", { displayYear: year.value })
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            const data = res.data.resList[0];
            items.value = data?.honors;
            displayYears.value = data?.years;
            if (year.value === 0) {
              year.value = displayYears.value[0];
            }
          } else {
            items.value = [];
            displayYears.value = [];
            alert(res.data.resMsg);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          hideLoading();
        });
    };
    const nullFormatter = (data) => {
      if (!dc.nullChk(data)) {
        return "-";
      }
      return data;
    };
    // life cycle 정의
    onMounted(() => {
      getList();
    });
    // html에서 사용될 데이터 정의
    return {
      items,
      year,
      displayYears,
      img_gold,
      img_silver,
      img_bronze,
      nullFormatter,
      getList,
    };
  },
};
</script>
